import { render, staticRenderFns } from "./pg-delAccount.vue?vue&type=template&id=582bfe31&scoped=true"
import script from "./pg-delAccount.vue?vue&type=script&lang=js"
export * from "./pg-delAccount.vue?vue&type=script&lang=js"
import style1 from "./pg-delAccount.vue?vue&type=style&index=1&id=582bfe31&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "582bfe31",
  null
  
)

export default component.exports